import React from "react";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import ExlyImage from "repoV2/features/Common/modules/ExlyImage/ExlyImage";
import styles from "./MerchandiseTitleSection.module.scss";

const MerchandiseTitleSection = (props: { varinatImages: string[] }) => {
    const { varinatImages } = props;

    const { title, defaultListingTitle, coverImage } =
        useCheckoutBasicDetailsContext();

    return (
        <div className={styles.titleImageContainerStyles}>
            <ExlyImage
                className={styles.imageStyles}
                // in checkout pages, with page speed being priority we do not show
                // any carousal like thing, and only show the first image of the variant
                src={varinatImages[0] || coverImage}
                alt={defaultListingTitle}
            />
            <div
                className={styles.titleStyles}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: title || defaultListingTitle,
                }}
            />
        </div>
    );
};

export default MerchandiseTitleSection;
